module.exports = {
  platform: 'voice',
  name: 'Mail',
  node: 'mail',
  bg: '#FFFFFF',
  note: '',
  property: {
    to: '',
    cc: '',
    subject: '',
    body: '',
    attachments: [],
    setting: {
      timeout: '30.0',
      await: false
    }
  }
}
